import { render, staticRenderFns } from "./coreCompetence.vue?vue&type=template&id=f9781b84&scoped=true&"
import script from "./coreCompetence.vue?vue&type=script&lang=js&"
export * from "./coreCompetence.vue?vue&type=script&lang=js&"
import style0 from "./coreCompetence.vue?vue&type=style&index=0&id=f9781b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9781b84",
  null
  
)

export default component.exports